"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecurityContextHolder = void 0;
var _uuid = require("uuid");
var _SecurityContext = _interopRequireDefault(require("./SecurityContext"));
var _MenuHistoryHolder = require("./MenuHistoryHolder");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// eslint-disable-next-line import/no-cycle

const getSessionStorage = () => {
  try {
    return window.opener && window.opener.document && window.opener.document.domain === window.document.domain ? window.opener.sessionStorage : sessionStorage;
    // eslint-disable-next-line no-empty
  } catch {}
  return sessionStorage;
};
const appStorage = getSessionStorage();

// Have to fix the dependency cycle! For now it does not seem to affect anything

// eslint-disable-next-line import/prefer-default-export
class SecurityContextHolder {
  static isAuthenticated() {
    return SecurityContextHolder.getCurrentContext() != null;
  }
  static getCurrentContext() {
    const currentContext = appStorage.getItem(_CURRENT_CONTEXT_KEY._);
    return currentContext ? _SecurityContext.default.from(JSON.parse(currentContext)) : null;
  }
  static setCurrentContext(currentContext) {
    appStorage.setItem(_CURRENT_CONTEXT_KEY._, JSON.stringify(currentContext));
  }
  static generateRouteUUID() {
    const routeUUID = (0, _uuid.v4)();
    appStorage.setItem(_CURRENT_ROUTE_UUID._, routeUUID);
    return routeUUID;
  }
  static getRouteUUID() {
    const routeUUID = appStorage.getItem(_CURRENT_ROUTE_UUID._);
    return routeUUID || this.generateRouteUUID();
  }
  static reset() {
    appStorage.removeItem(_CURRENT_CONTEXT_KEY._);
    _MenuHistoryHolder.MenuHistoryHolder.reset();
  }
  static isExpired() {
    return !this.isAuthenticated() || this.getCurrentContext().expirationDate < Date();
  }
  static hasPrivilege(privilege) {
    if (this.isAuthenticated() && this.getCurrentContext()) {
      const {
        privileges
      } = this.getCurrentContext();
      if (privileges) {
        const matchingPrivileges = privileges === null || privileges === void 0 ? void 0 : privileges.filter(item => item.name === privilege);
        return (matchingPrivileges === null || matchingPrivileges === void 0 ? void 0 : matchingPrivileges.length) > 0;
      }
    }
    return false;
  }
}
exports.SecurityContextHolder = SecurityContextHolder;
var _CURRENT_CONTEXT_KEY = {
  _: 'SecurityContext'
};
var _CURRENT_ROUTE_UUID = {
  _: 'current.route.uuid'
};
//# sourceMappingURL=SecurityContextHolder.js.map